<template>
  <div class="sms_record">
    <!-- 短信记录 -->
    <div v-if="!showEffect">
    <top-title :name="name"></top-title>
    <!-- <div class="message_num">官方短信剩余：<span :style="{'color':globalBG}">100</span> 条 <span class="recharge">充值</span></div> -->
    <div class="section-right-content-box">
      <!-- 提示 -->
      <div class="tip_module">
        <span class="i_icon">i</span>
        <div>
          <div>1.此功能为京东官方功能，请先报备店铺签名，再筛选人群数据哦；且短信发送后第二天才可查看营销效果分析~&nbsp;&nbsp;&nbsp;<span :style="{'color':globalBG}" style="cursor: pointer;" @click="toSet">去设置</span></div>
          <div>2.官方规定：每个商家的人群策略最多创建300个（不包含系统人群），若您的策略已到达上限，请先删除一些无用分组，再进行人群创建 </div>
        </div>

      </div>

      <div class="search_module">

        <!-- 筛选部分 -->
        <div class="screen-box" style="text-align: left;" :model="searchParams">
            <div class="input-box"> 
              <p class="input-title">活动主题：</p>
              <el-input
                v-model="searchParams.theme"
                placeholder="输入活动主题"
                size="small"
                style="width: 280px;"
              ></el-input>
            </div>

            <div class="input-box"> 
              <p class="input-title">短信内容：</p>
              <el-input
                v-model="searchParams.messageContent"
                placeholder="输入短信内容"
                size="small"
                style="width: 280px;"
              ></el-input>
            </div>

            <div class="input-box" style="">
              <p class="input-title">活动类型：</p>
              <el-select
                v-model="searchParams.activityType"
                placeholder="请选择"
                size="small"
                style="width: 280px;"
              >
                <el-option
                  v-for="item in activityTypeList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>

            <div class="input-box" style="">
              <p class="input-title">发送状态：</p>
              <el-select
                v-model="searchParams.status"
                placeholder="请选择"
                size="small"
                style="width: 280px;"
              >
                <el-option
                  v-for="item in stautsOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>

            <div class="input-box my_select_time">
              <div class="input-title">提交时间：</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="searchParams.submitStartTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px;font-size:12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="searchParams.submitEndTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px;font-size:12px"
                class="time2"
                :clearable="false"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime2"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2">
            </div>

            <div class="input-box my_select_time">
              <div class="input-title">发送时间：</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="searchParams.sendStartTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px;font-size:12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="searchParams.sendEndTime"
                type="datetime"
                placeholder="选择日期时间"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px;font-size:12px"
                class="time2"
                :clearable="false"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2">
            </div>
        
            <div class="input-box">
              <el-button icon="el-icon-search"  class="search_btn" size="small" :style="{'color':globalBG,'border-color':globalBG}" @click="search" :disabled="tableLoading">查询</el-button>
              <el-button
                class="status_btn status_btn2"
                @click="resetBtn"
              >重置</el-button>
            </div>
         
        </div>
      </div>

      <div class="table_module">

        <!-- 表格部分 -->
        <div class="table-box">
          <el-table
            ref="multipleTable"
            tooltip-effect="light"
            :data="tableData"
            :header-cell-style="{background:'#FAFAFA'}"
            style="width: 100%; border: 1px solid #eee;"
            stripe
            v-loading="tableLoading"
          >
            <template slot="empty">
              <div style="margin: 20px;">
                <img src="../../assets/images/nodata.png" style="display: inline-block; vertical-align: middle; cursor: pointer;">
                  <span class="nodata1">暂无数据</span>
              </div>
            </template>
            <!-- <el-table-column type="selection" width="40"></el-table-column> -->
            <el-table-column label="活动主题" prop="theme"></el-table-column>
            <el-table-column label="活动类型" prop="activityType" width="90"></el-table-column>
            <el-table-column label="短信内容" prop="messageContent" min-width="180"></el-table-column>
            <el-table-column label="发送状态" prop="status" width="110">
              <template slot-scope="scope">
                <span class="circle_icon" :style="{'background': selectColor(scope.row.status)}"></span>
                <span style="margin: 0 4px 0 8px;">{{scope.row.status | statusStr}}</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="scope.row.failReason"
                  placement="top-start"
                  v-if="scope.row.status == 0"
                >
                  <span class="question_icon">?</span>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="提交时间" prop="submitStartTime" width="160"></el-table-column>
            <el-table-column label="发送时间" prop="sendStartTime" width="160"></el-table-column>
            <el-table-column label="发送人数" prop="sendNum" ></el-table-column>
            <el-table-column label="短信量" prop="messageNum" ></el-table-column>
            <el-table-column label="操作" min-width="130">
              <template slot-scope="scope">
                <span style="color: #333333;font-size: 18px;padding-left: 10px!important;" v-if="scope.row.status==0 || scope.row.status==1 || scope.row.status==4">-</span>
                <div v-if="scope.row.status!=0 && scope.row.status!=1 && scope.row.status!=4">
                  <el-button
                    type="text"
                    @click="openRecord(scope.$index, scope.row.smsBlacklistId)"
                    :style="{'color':'#7F85E9'}"
                  >短信记录</el-button>
                  <el-button
                    type="text"
                    @click="cancelSend(scope.$index, scope.row.smsBlacklistId)"
                    :style="{'color':globalBG}"
                    style="margin-left: 0px;"
                    v-if="scope.row.status==2"
                  >取消发送</el-button>
                  <el-button
                    type="text"
                    @click="toShowEffect(scope.$index, scope.row.smsBlacklistId)"
                    :style="{'color':globalBG}"
                    style="margin-left: 0px;"
                    v-if="scope.row.status==3"
                  >效果分析</el-button>
                  <el-button
                    type="text"
                    @click="secondSend(scope.$index, scope.row.smsBlacklistId)"
                    :style="{'color':globalBG}"
                    style="margin-left: 0px;"
                    v-if="scope.row.status==3 && scope.row.activityType!='订单发送'"
                  >再次营销</el-button>
                </div>
                
              </template>
            </el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div class="block">
            <el-pagination
              background
              style="text-align: right; margin-top: 20px;"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="searchParams.pageNum"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="searchParams.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCount.total"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    </div>
    <!-- 效果分析 -->
    <div v-if="showEffect">
      <!--头部信息 -->
      <div class="top_content">
        <div class="top_first">
          <span class="top_title">营销效果分析</span>
          <span class="top_return" @click="showEffect = false">返回列表</span>
          <span>
            ROI（投入产出比）: 
            <span style="color: #7F85E9">1:825</span>
            <span class="top_edit" :style="{'color':globalBG}" v-if="!editROI" @click="editROI = true">修改</span>
            
            <el-input
              v-model="ROINum"
              placeholder="请输入内容"
              size="small"
              class="roi_input"
              style=""
              v-if="editROI"
            ></el-input>
            <span class="top_edit" :style="{'color':globalBG}" v-if="editROI" @click="editROI = false">确定</span>
          </span>
        </div>
        <div class="top_tips"><span class="i_icon i_icon2">i</span>营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供，无法查看到会员明细数据</div>
      </div>

      <!-- 短信内容 -->
      <div class="message_content">
        <div style="margin-bottom: 28px;">
          <span style="margin-right: 80px;">状态：<span class="circle_icon2"></span><span style="color: #666666;">已发送</span></span>
          <span>会员总数：<span :style="{'color':globalBG}">71&nbsp;</span>人</span>
        </div>
        <div>短信内容：【悦信旗舰店】年货节开始啦，辛苦了一年，是时候给自己的厨房换套新刀具啦~直降/赠品/秒杀，更多优惠搜索京东</div>
      </div>

      <!-- 数据统计 -->
      <div class="total_content">
        <div>
          <div class="input_box my_select_time">
            <div class="input_title">统计时间：</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="totalParams.totalStartTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 120px;font-size:12px"
              class="time1"
              :clearable="false"
            ></el-date-picker>
            <div class="time_to_text">至</div>
            <el-date-picker
              prefix-icon="no_icon"
              v-model="totalParams.totalEndTime"
              type="datetime"
              placeholder="选择日期时间"
              size="small"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width: 145px;font-size:12px"
              class="time2"
              :clearable="false"
            >
            </el-date-picker>
            <i class="el-icon-circle-close date_icon1"  @click="clearTime3"></i>
            <img src="@/assets/images/select_date.svg" alt="" class="date_icon2">
          </div>

          <el-button
            icon="el-icon-search"
            type="primary"
            class="status_btn"
            :style="{'color':globalBG,'border-color':globalBG}"
            style="margin-left: 20px"
            @click="totalSeacher"
          >查询</el-button>
          
        </div>
        <div class="data_item_all">
          <!-- 目标客户 -->
          <div class="data_item">
            <div class="item_top"><span class="line"></span><span>目标客户</span></div>
            <div class="item_content">
              <div class="item_content_item">预计触达人数： 5 人</div>
              <div class="item_content_item">实际触达人数： 1 人</div>
            </div>
          </div>
          <!-- 访问响应客户 -->
          <div class="data_item">
            <div class="item_top"><span class="line" style="background: #5882FB"></span><span>访问响应客户</span></div>
            <div class="item_content">
              <div class="item_content_item">短链点击次数：- 次</div>
              <div class="item_content_item">短链访问人数：- 人</div>
              <div class="item_content_item">商品详情页访问：45</div>
              <div class="item_content_item">店铺首页访问：3</div>
              <div class="item_content_item">店铺加购人数：2 人</div>
              <div class="item_content_item">收藏商品人数：- 人</div>
              <div class="item_content_item">收藏店铺人数：- 人</div>
            </div>
          </div>
          <!-- 下单响应客户 -->
          <div class="data_item">
            <div class="item_top">
              <span class="line" style="background: #FE4D45"></span><span>下单响应客户</span>
              <el-tooltip
                class="item"
                effect="light"
                content="下单客户数/实际触达客户数*100%"
                placement="top-start"
                style="margin-left: 4px;"
              >
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
            <div class="item_content">
              <div class="item_content_item">下单响应率：0.00 %</div>
              <div class="item_content_item">下单人数：- 人</div>
              <div class="item_content_item">下单金额：- 元</div>
              <div class="item_content_item">下单订单数：- 单</div>
              <div class="item_content_item">下单件数：- 件</div>
            </div>
          </div>
          <!-- 成交响应客户 -->
          <div class="data_item">
            <div class="item_top">
              <span class="line" style="background: #FE4D45"></span><span>成交响应客户</span>
              <el-tooltip
                class="item"
                effect="light"
                content="成交客户数/实际触达客户数*100%"
                placement="top-start"
                style="margin-left: 4px;"
              >
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
            <div class="item_content">
              <div class="item_content_item">成交响应率： 0.00 %</div>
              <div class="item_content_item">成交人数： - 人</div>
              <div class="item_content_item">成交金额： - 元</div>
              <div class="item_content_item">成交订单数： - 件</div>
              <div class="item_content_item">成交件数： 0.00 件</div>
            </div>
          </div>
          <!-- 优惠券响应客户 -->
          <div class="data_item">
            <div class="item_top">
              <span class="line" style="background: #FF872F"></span><span>优惠券响应客户</span>
              <el-tooltip
                class="item"
                effect="light"
                content="领券人数/实际触达客户数*100%"
                placement="top-start"
                style="margin-left: 4px;"
              >
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
            <div class="item_content">
              <div class="item_content_item">领劵响应率：0.00 %</div>
              <div class="item_content_item">领劵人数：- 人</div>
              <div class="item_content_item">用劵人数：- 人</div>
              <div class="item_content_item">优惠劵引入订单：- 单</div>
              <div class="item_content_item">优惠劵引入金额：- 元</div>
            </div>
          </div>
          <!-- 营销洞察 -->
          <div class="data_item">
            <div class="item_top">
              <span class="line" style="background:  #7F85E9 "></span><span>营销洞察</span>
              <el-tooltip
                class="item"
                effect="light"
                placement="top-start"
                style="margin-left: 4px;"
              >
                <div slot="content">
                  已购会员购买客户数：触达后统计时间内当日下单客户中是已购会员的客户数<br/>
                  品牌开卡会员购买客户数：触达后统计时间内当日下单客户中是品牌开卡会员的客户数<br/>
                  店铺开卡会员购买客户数：触达后统计时间内当日下单客户中是开卡会员的客户数<br/>
                  品牌开卡会员购买新客户数：触达后统计时间内当日下单新客户(有记录以来第一次下单)中是品牌开卡会员的客户数<br/>
                  店铺开卡会员购买新客户数：触达后统计时间内当日下单新客户(有记录以来第一次下单)中是店铺开卡会员的客户<br/>
                </div>
                <span class="question_icon">?</span>
              </el-tooltip>
            </div>
            <div class="item_content">
              <div class="item_content_item">已购会员购买客户数：- 人</div>
              <div class="item_content_item">品牌开卡会员购买客户数：- 人</div>
              <div class="item_content_item">店铺开卡会员购买客户数：- 人</div>
              <div class="item_content_item">品牌开卡会员购买新客户数：- 人</div>
              <div class="item_content_item">店铺开卡会员购买新客户数：- 人</div>
            </div>
          </div>
        </div>
      </div>

      <!-- TOP排行榜 -->
      <div class="TOP_content2">
        <!-- tab栏 -->
        <div class="tab_item_all">
          <span class="tab_item" :class="{'select_item': selectTop==1}" @click="selectTop=1">浏览商品TOP10</span>
          <span class="tab_item" :class="{'select_item': selectTop==2}" @click="selectTop=2">架构商品TOP10</span>
          <span class="tab_item" :class="{'select_item': selectTop==3}" @click="selectTop=3">付款商品TOP10</span>
        </div>
        <!-- 浏览商品TOP10 -->
        <div style="padding: 20px 28px 0px;" v-if="selectTop==1">
          <el-table
            tooltip-effect="light"
            :data="topTableData1"
            :header-cell-style="{background:'#fafafa'}"
            style="width: 100%; border: 1px solid #eee;"
            show-summary
            v-loading="topLoading1"
          >
            <template slot="empty">
              <div style="margin: 20px;">
                <img src="../../assets/images/nodata.png" style="display: inline-block; vertical-align: middle; cursor: pointer;">
                  <span class="nodata1">暂无数据</span>
              </div>
            </template>
            <el-table-column label="排行榜" prop="nickName" width="80">
              <template slot-scope="scope">
                {{scope.$index+1}}
              </template>
            </el-table-column>
            <el-table-column label="商品" prop="shop" min-width="220">
              <template slot-scope="scope">
                <div>{{scope.row.shopName}}</div>
                <div>skuid：{{scope.row.skuId}}</div>
              </template>
            </el-table-column>
            <el-table-column label="pv（次数）" prop="pvNum"></el-table-column>
            <el-table-column label="pv（人）" prop="pvPeople"></el-table-column>
          </el-table>

        </div>
        <!-- 架构商品TOP10 -->
        <div style="padding: 20px 28px 0px;" v-if="selectTop==2">
          <el-table
            tooltip-effect="light"
            :data="topTableData2"
            :header-cell-style="{background:'#fafafa'}"
            style="width: 100%; border: 1px solid #eee;"
            show-summary
            v-loading="topLoading2"
          >
            <template slot="empty">
              <div style="margin: 20px;">
                <img src="../../assets/images/nodata.png" style="display: inline-block; vertical-align: middle; cursor: pointer;">
                  <span class="nodata1">暂无数据</span>
              </div>
            </template>
            <el-table-column label="排行榜" prop="nickName" width="80">
              <template slot-scope="scope">
                {{scope.$index+1}}
              </template>
            </el-table-column>
            <el-table-column label="商品" prop="shop" min-width="220">
              <template slot-scope="scope">
                <div>{{scope.row.shopName}}</div>
                <div>skuid：{{scope.row.skuId}}</div>
              </template>
            </el-table-column>
           <el-table-column label="客户数（人）" prop="peopleNum"></el-table-column>
           <el-table-column label="件数（件）" prop="pieceNum"></el-table-column>
          </el-table>
        </div>
        <!-- 付款商品TOP10 -->
        <div style="padding: 20px 28px 0px;" v-if="selectTop==3">
          <el-table
            tooltip-effect="light"
            :data="topTableData3"
            :header-cell-style="{background:'#fafafa',height: '50px'}"
            style="width: 100%; border: 1px solid #eee;"
            show-summary
            v-loading="topLoading3"
          >
            <template slot="empty">
              <div style="margin: 20px;">
                <img src="../../assets/images/nodata.png" style="display: inline-block; vertical-align: middle; cursor: pointer;">
                  <span class="nodata1">暂无数据</span>
              </div>
            </template>
            <el-table-column label="排行榜" prop="nickName" width="80">
              <template slot-scope="scope">
                {{scope.$index+1}}
              </template>
            </el-table-column>
            <el-table-column label="商品" prop="shop" min-width="220">
              <template slot-scope="scope">
                <div>{{scope.row.shopName}}</div>
                <div>skuid：{{scope.row.skuId}}</div>
              </template>
            </el-table-column>
            <el-table-column label="客户数（人）" prop="peopleNum"></el-table-column>
            <el-table-column label="件数（件）" prop="pieceNum"></el-table-column>
            <el-table-column label="金额（元）" prop="money"></el-table-column>
          </el-table>
        </div>

      </div>

    </div>


    <!-- 短信记录-弹窗 -->
    <el-dialog
      title="短信记录"
      :visible.sync="smsRecordDialog"
      width="1060px">
      <div>
        <!-- 查询部分 -->
        <div>
            <div class="search_item"> 
              <p class="title">买家昵称：</p>
              <el-input
                v-model="smsSearchParams.nickName"
                placeholder="输入短信内容"
                size="small"
                style="width: 200px;"
              ></el-input>
            </div>

            <div class="search_item"> 
              <p class="title">手机号码：</p>
              <el-input
                v-model="smsSearchParams.phone"
                placeholder="输入短信内容"
                size="small"
                style="width: 116px;"
              ></el-input>
            </div>

            <div class="search_item">
              <p class="title">发送状态：</p>
              <el-select
                v-model="smsSearchParams.receiveStatus"
                placeholder="请选择"
                size="small"
                style="width: 136px;"
              >
                <el-option
                  v-for="item in receiveStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>

            <el-button
              icon="el-icon-search"
              type="primary"
              class="status_btn"
              :disabled="tableLoading2"
              :style="{'color':globalBG,'border-color':globalBG}"
              @click="smsSeacher"
            >查询</el-button>
            <el-button
              class="status_btn status_btn2"
              @click="resetBtn2"
            >重置</el-button>
        </div>
        <!-- 表格 -->
        <div>
          <el-table
            ref="multipleTable"
            tooltip-effect="light"
            :data="smsTableData"
            style="width: 100%; border: 1px solid #eee;"
            stripe
            v-loading="tableLoading2"
          >
            <template slot="empty">
              <div style="margin: 20px;">
                <img src="../../assets/images/nodata.png" style="display: inline-block; vertical-align: middle; cursor: pointer;">
                  <span class="nodata1">暂无数据</span>
              </div>
            </template>
            <el-table-column label="买家昵称" prop="nickName"></el-table-column>
            <el-table-column label="手机号码" prop="phone" width="120"></el-table-column>
            <el-table-column label="短信内容" prop="messageContent" min-width="220"></el-table-column>
            <el-table-column label="计费条数" prop="sendNum"></el-table-column>
            <el-table-column label="发送状态" prop="receiveStatus" width="130">
              <template slot-scope="scope">
                <span>{{scope.row.receiveStatus | smsStatusStr}}</span>
              </template>
            </el-table-column>
            <el-table-column label="发送时间" prop="sendTime" width="170"></el-table-column>
          </el-table>
          <!-- 分页器 -->
          <div class="block">
            <el-pagination
              background
              style="text-align: right; margin-top: 20px;"
              @size-change="handleSizeChange2"
              @current-change="handleCurrentChange2"
              :current-page="smsSearchParams.pageNum"
              :page-sizes="[10, 20, 30, 50, 100, 500]"
              :page-size="smsSearchParams.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="smsTotal"
            ></el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 删除确认弹窗 -->
    <el-dialog
      title="提示"
      :visible.sync="sureDialogVisible"
      width="400px"
      style="margin-top: 25vh;">
      <div class="sure_text">
        <img src="../../assets/images/i_icon.png" class="i_icon">
        <span>确定要删除吗？</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sureDialogVisible = false" class="width_96">取 消</el-button>
        <el-button type="primary" @click="sureDialogVisible = false" class="width_96">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
// import {
//   addBlackList,
//   deleteBlackList,
//   deleteBlackListByCondition,
//   exportBlackList,
//   getBlackList,
//   importBlackList,
//   blackUploadMobileFile,
//   // uploadMobileFile
// } from "@/api/backList";
import {mapState} from 'vuex'
import topTitle from "@/components/top-title.vue";
const cityOptions = ["手机号码", "备注", "添加时间"];
const cityOption = true;
// const city
export default {
  name: "sms_record",
  components: {
    topTitle,
  },
  filters: {
      statusStr(status){
          return {0:"提交失败",1:"待审核",2:"待发送",3:"已发送",4:"已取消","null":"null"}[status];
      },
      smsStatusStr(status){
          return {0:"已发送",1:"未发送",2:"黑名单过滤",3:"10分钟内容重复",4:"过滤重复发送",5:"无效号码","null":"null"}[status];
      },
  },
  data() {
    return {
      selectTop: 1,
      totalParams: {
        totalStartTime: '',
        totalEndTime: '',
      },
      editROI: false, // 修改ROI
      ROINum: '',
      showEffect: false, // 显示效果分析
      // showEffect: true, // 显示效果分析  xxxxxxxxxxxxxxxx
      smsTotal: '',
      smsSearchParams: {
        pageNum: 1,
        pageSize: 10,
        total: '100',

        nickName: '', 
        phone: '', 
        receiveStatus: '', 
      },
      // 短信记录状态
      receiveStatusList: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "已发送"
        },
        {
          value: "1",
          label: "未发送"
        },
        {
          value: "2",
          label: "黑名单过滤"
        },
        {
          value: '3',
          label: '10分钟内容重复'
        },
        {
          value: "4",
          label: "过滤重复发送"
        },
        {
          value: "5",
          label: "无效号码"
        },
      ],
      smsRecordDialog: false, // 短信记录弹窗
      activityTypeList: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "订单发送"
        },
        {
          value: "1",
          label: "精准营销"
        },
      ],
      stautsOptions: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "提交失败"
        },
        {
          value: "1",
          label: "待审核"
        },
        {
          value: "2",
          label: "待发送"
        },
        {
          value: '3',
          label: '已发送'
        },
        {
          value: "4",
          label: "已取消"
        },
      ],
      name: '短信记录',
      timeRangePicker: ['', ''],
      tableLoading: false,
      tableLoading2: false,
      topLoading1: false,
      topLoading2: false,
      topLoading3: false,
      sureDialogVisible: false, // 确认删除弹窗
      // pickerOptionsEnd: {
      //   disabledDate: time => {
      //     if (this.searchParam2.startTime) {
      //       return (
      //         time.getTime() <
      //         new Date(this.searchParam2.startTime).getTime()
      //       );
      //     } else {
      //     }
      //   }
      // },
      // pickerOptionsStart: {
      //   disabledDate: time => {
      //     if (this.searchParam2.endTime) {
      //       return (
      //         time.getTime() >
      //         new Date(this.searchParam2.endTime).getTime()
      //       );
      //     } else {
      //     }
      //   }
      // },
      fileId:'',
      mobileType:'0',
      remark:'',
      uploadUrl: "",
      fileName: "",
      fileList: [],
      cellPhon: "",
      wangWang: "",
      process:0,
      success:'',
      stateColor:'#409eff',
      proTimer:null,
      isupload:false,
      uid: "", //导入的文件id
      wordLength: 0, //获取备注字数长度
      commentTextarea: "", //加入黑名单文本数据框
      addChecked: 1, //加入黑名单选择类型数据按钮
      exportDialog: false, //导出数据
      totalCount: [], //数据总条数
      addBlackList: false, //添加黑名单按钮
      exportDer: false, //导出数据
      phoneTextarea: [], //手机号码输入框
      remarkTextarea: "", //备注输入框
      joinRemarkTextarea: "", //加入黑名单备注内容
      multipleSelection: [], //表格多选数据
      taskTime: [], //时间绑定
      
      // 浏览商品TOP10
      topTableData1: [
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'pvNum': 6,
          'pvPeople': 5,
        },
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'pvNum': 2,
          'pvPeople': 3,
        },
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'pvNum': 4,
          'pvPeople': 7,
        },
      ],
      // 架构商品TOP10
      topTableData2: [
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'peopleNum': 1,
          'pieceNum': 5,
        },
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'peopleNum': 4,
          'pieceNum': 8,
        },
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'peopleNum': 3,
          'pieceNum': 9,
        },
      ],
      // 架构商品TOP10
      topTableData3: [
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'peopleNum': 1,
          'pieceNum': 5,
          'money': 15.25,
        },
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'peopleNum': 4,
          'pieceNum': 8,
          'money': 18.00,
        },
        { 
          'shopName': '初缘天然玉手镯母亲节送妈妈礼物感恩节送长辈过年回家送奶奶生日礼物礼盒包',
          'skuId': '56378742084',
          'peopleNum': 3,
          'pieceNum': 9,
          'money': 2,
        },
      ],
      smsTableData: [
        { 
          'nickName': '王小小',
          'phone': '17875512043',
          'messageContent': '【雁书1233】123213123213123123回T退',
          'sendNum': '1',
          'receiveStatus': '3',
          'sendTime': '2018-06-06 19:37:03',
        },
      ],
      tableData: [
        { 
          'theme': '20180614全部宝贝',
          'activityType': '订单发送',
          'messageContent': '【123旗舰店】我在你口袋塞了一张50元无门生物学优僡券，快去瞧瞧，不要声张回T退订',
          'status': '0',
          'failReason': '我是失败的原因',
          'submitStartTime': '2018-06-06 19:37:03',
          'sendStartTime': '2018-06-06 19:37:03',
          'sendNum': '1000',
          'messageNum': '1836984',
        },
        { 
          'theme': '20180614全部宝贝',
          'activityType': '订单发送',
          'messageContent': '【123旗舰店】我在你口袋塞了一张50元无门生物学优僡券，快去瞧瞧，不要声张回T退订',
          'status': '1',
          'submitStartTime': '2018-06-06 19:37:03',
          'sendStartTime': '2018-06-06 19:37:03',
          'sendNum': '1000',
          'messageNum': '1836984',
        },
        { 
          'theme': '20180614全部宝贝',
          'activityType': '订单发送',
          'messageContent': '【123旗舰店】我在你口袋塞了一张50元无门生物学优僡券，快去瞧瞧，不要声张回T退订',
          'status': '2',
          'submitStartTime': '2018-06-06 19:37:03',
          'sendStartTime': '2018-06-06 19:37:03',
          'sendNum': '1000',
          'messageNum': '1836984',
        },
        { 
          'theme': '20180614全部宝贝',
          'activityType': '订单发送',
          'messageContent': '【123旗舰店】我在你口袋塞了一张50元无门生物学优僡券，快去瞧瞧，不要声张回T退订',
          'status': '3',
          'submitStartTime': '2018-06-06 19:37:03',
          'sendStartTime': '2018-06-06 19:37:03',
          'sendNum': '1000',
          'messageNum': '1836984',
        },
        { 
          'theme': '20180614全部宝贝',
          'activityType': '精准营销',
          'messageContent': '【123旗舰店】我在你口袋塞了一张50元无门生物学优僡券，快去瞧瞧，不要声张回T退订',
          'status': '3',
          'submitStartTime': '2018-06-06 19:37:03',
          'sendStartTime': '2018-06-06 19:37:03',
          'sendNum': '1000',
          'messageNum': '1836984',
        },
        { 
          'theme': '20180614全部宝贝',
          'activityType': '订单发送',
          'messageContent': '【123旗舰店】我在你口袋塞了一张50元无门生物学优僡券，快去瞧瞧，不要声张回T退订',
          'status': '4',
          'submitStartTime': '2018-06-06 19:37:03',
          'sendStartTime': '2018-06-06 19:37:03',
          'sendNum': '1000',
          'messageNum': '1836984',
        },
      ], //请求黑名单列表的数据
      dialogVisible: false,
      radio: "1", //绑定弹框
      /* 
      导出数据弹窗
      */
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: false,
      educe: {
        buyerNick: "",
        endCreateTime: "",
        exportCell: ["手机号码", "备注", "添加时间"],
        mobile: "",
        remark: "",
        buyerNick: "",
        startCreateTime: ""
      },
      /* 
      导入数据弹窗
      */
      checked: false,
      checke: false,
      /* 
      表格数据
      */
      searchParams: {
        // buyerNick: "",
        // endCreateTime: "",
        pageNum: 1,
        pageSize: 10,
        // mobile: "",
        // remark: "",
        // buyerNick: "",
        // startCreateTime: "",

        theme: '', 
        messageContent: '', 
        activityType: '', 
        status: '', 
        sendStartTime: '', 
        sendEndTime: '', 
        submitStartTime: '', 
        submitEndTime: '',
       
      },
      // form表单
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: ""
      },
      //taskTimeChange:"",
      importTipDialog:false,//导入成功后显示的提示信息框
      successNum:"",
      importTotalNum:"",
      searchParam2: {
        startTime: "",
        endTime: "",
      },
    };
  },
  
  //监听日期时间改变
  computed: {
    loadState(){//进度条状态
      if(this.success===''){this.stateColor="#409eff"; return `上传中(%${this.process})`};
      if(this.process===100 && this.success===true){this.stateColor="#49C568"; return `上传成功`;}
      if(this.process===100 && this.success===false){this.stateColor="#F56C6C"; return `上传失败`;}
    },
    taskTimeChange: {
      get: function() {
        return this.taskTime;
      },
      set: function(value) {
        // console.log(value)
        this.taskTime = value;
        // console.log(value);
        this.searchParams.startCreateTime = value[0];
        this.searchParams.endCreateTime = value[1];
        
      }
    },
    ...mapState({
          globalBG:"globalBG",      
        //   把city映射给currentCIty
      })
  },
  watch:{
    taskTimeChange(value){
       value[1] = new Date(this.ToStrfommatShort(value[1])+" 23:59:59")
    }
  },
  methods: {
    
    // 统计-查询
    totalSeacher(){

    },
    // 短信记录-查询
    smsSeacher(){

    },
    // 再次营销
    secondSend(index,id){
      this.smsRecordDialog = true;
    },
    // 取消发送
    cancelSend(index,id){
      this.sureDialogVisible = true;
    },
    // 打开短信记录弹窗
    openRecord(index,id){
      this.smsRecordDialog = true;
    },
    // 显示效果分析部分
    toShowEffect(){
      this.showEffect = true;
    },
    // 选择颜色
    selectColor(val){
      return {0:"#FE4D45",1:"#7F85E9",2:"#FFB95E",3:"#49C568",4:"#CCCCCC","null":"null"}[val];
    },
    // 跳转到短信充值页面
    toSet(){
      let routeUrl = this.$router.resolve({
        path: "/backstage",
        query: { to: "/backstage/smsmanage/charge" }
      });
      window.open(routeUrl.href, "_blank");
    },
    // 短信记录-重置
    resetBtn2(){
      this.searchParams.nickName = "";
      this.searchParams.phone = "";
      this.smsSearchParams.receiveStatus = "";
    },
    // 重置
    resetBtn(){
      this.searchParams.theme = "";
      this.searchParams.messageContent = "";
      this.searchParams.activityType = "";
      this.searchParams.status = "";
      this.searchParams.sendStartTime = "";
      this.searchParams.sendEndTime = "";
      this.searchParams.submitStartTime = "";
      this.searchParams.submitEndTime = "";
    },
    // 清空时间
    clearTime(){
      this.searchParams.sendStartTime = "";
      this.searchParams.sendEndTime = "";
    },
    // 清空时间
    clearTime2(){
      this.searchParams.submitStartTime = "";
      this.searchParams.submitEndTime = "";
    },
    // 统计时间-清空
    clearTime3(){
      this.totalParams.totalStartTime = "";
      this.totalParams.totalEndTime = "";
    },
    

    closePro(ev){
      this.isupload=false;
      ev.cancelBubble=true;//阻止冒泡
    },
    reload(ev){
      // console.log(this.$refs);
      this.$refs.upload.$children[0].$el.click();
      ev.cancelBubble=true;//阻止冒泡
    },
    /* 
     添加黑名单获取备注内容字数
    */
    changeData(val) {
      this.wordLength = val.length;
    },
    /* 
     添加黑名单绑定按钮事件
    */
    buyersWant(val) {
      this.remarkTextarea = '';
      this.commentTextarea = "";
      this.addChecked = val;
    },
    /* 
    导出数据
    */
    handleCheckAllChange(val) {
      this.checkedCities = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      // console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    /* 
     黑名单列表请求函数
    */
    backTolist() {
      
      // let time1 = this.searchParam2.startTime;
      let time1 = this.timeRangePicker[0];
      // let time2 = this.searchParam2.endTime;
      let time2 = this.timeRangePicker[1];
      this.searchParams.startCreateTime = '';
      this.searchParams.endCreateTime ='';
      if(time1){
        if(time1.length==0 || typeof(time1)=="null" ){
        }else{
          this.searchParams.startCreateTime = time1;
        }
      }
      if(time2){
       if(time2.length==0 || typeof(time2)=="null" ){
        }else{
          this.searchParams.endCreateTime = time2;
        }
      }

      this.tableLoading = true;
      getBlackList(this.searchParams).then(res => {
        if(res.code == 200){
          this.tableData = res.data.records;
          this.totalCount = {total: res.data.total};
        }
        this.tableLoading = false;
      }).catch(err => {
        this.tableLoading = false;
      });
    },

    /* 
     搜索
    */
    search() {
      console.log('timeRangePicker', 111)
      this.searchParams.pageNum = 1;
      this.backTolist();
    },

    /* 
      分页事件
    */
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.backTolist();
    },
    handleCurrentChange(val) {
      this.searchParams.pageNum = val;
      this.backTolist();
    },
    /* 
      短信记录-分页事件
    */
    handleSizeChange2(val) {
      this.smsSearchParams.pageSize = val;
      // this.backTolist();
    },
    handleCurrentChange2(val) {
      this.smsSearchParams.pageNum = val;
      // this.backTolist();
    },
    /* 
     添加黑名单事件
    */
    addData() {
      console.log(this.remarkTextarea);
      // console.log(this.commentTextarea);
      //多情况,换行可以
      if (this.remarkTextarea.indexOf("\n") !== -1) {
        let stry = this.remarkTextarea.split("\n");
        this.remarkTextarea = stry.join(",");
      }
      addBlackList({
        estimate: this.addChecked,
        account: this.remarkTextarea,
        remark: this.commentTextarea
      }).then(res => {
        this.backTolist();
        this.addBlackList = false;
        this.$message.success(res.message);
        this.remarkTextarea = "";
        this.commentTextarea = "";
      });
    },
    /* 
    导出数据事件
    */
    exportData() {
      let that = this;
      if(!this.checkedCities.length){
        this.$message.warning("请选择要导出的数据");
        return
      }
      
      this.educe.exportCell = this.checkedCities;

      exportBlackList(this.educe).then(res => {
        if (res.code === 200) {
          let url = res.data;
          let start = url.lastIndexOf(".");
          // console.log(start);
          let type = url.substring(start);
          // console.log(type);
          let fileName = res.data;
          // let fileNameArr = fileName.split("/");
          // let newFileName = fileNameArr[fileNameArr.length-1];
          let elem = document.createElement("a");
          elem.style.display = "none";
          elem.href = that.$BaseUrl+"/file_xls/"+url;
          elem.setAttribute("download", fileName);
          document.body.appendChild(elem);
          elem.click();
        }
        this.exportDer = false;
      }).catch(err => {
        this.exportDer = false;
      });
    },
    downloadTemplate(){
      let url ='',fileName='';
      if(this.mobileType==='0'){
        url = "/api/templateDir/黑名单导入手机号模板.xlsx";
        fileName = "黑名单导入手机号模板.xlsx";
      }
      if(this.mobileType==='1'){
        url = "/api/templateDir/黑名单导入旺旺号模板.xlsx";
        fileName = "黑名单导入旺旺号模板.xlsx";
      }
      // let start = url.lastIndexOf(".");
      // let type = url.substring(start);
      let elem = document.createElement("a");
      elem.style.display = "none";
      elem.href = url;
      elem.setAttribute("download", fileName);
      document.body.appendChild(elem);
      elem.click();
    },
    /* 
    点击上传功能,上传之前的大小校验
    */
    beforeUpload(file) {
      let that=this;
      this.isupload=false;
      this.$nextTick(()=>{
        that.process=0;
        that.success='';
        that.isupload=true;
        that.proTimer=setInterval(()=>{
            if(that.process<100){that.process++;}else{
                clearInterval(that.proTimer);
            }
        },20);
      });
      // 这里是获取文件的id号
      this.uid = file.uid;
      this.files = file;
      const extension = file.name.split(".")[1] === "xls";
      const extension2 = file.name.split(".")[1] === "xlsx";
      const isLt2M = file.size / 1024 / 1024 < 50;
      if (!extension && !extension2) {
        this.$message.warning("上传模板只能是 xls、xlsx格式!");
        this.process=100;
        this.success=false;
        //this.fileList = [];
        return;
      }
      if (!isLt2M) {
        this.process=100;
        this.success=false;
        this.$message.warning("上传模板大小不能超过 50MB!");
        return;
      }
      this.fileName = file.name;
      // return false; // 返回false不会自动上传
    },
    /**
     * 上传文件成功
     */
    upLoadSuccess(file, fileList) {
      // console.log(this.fileList);
      console.log('upLoadSuccess==',file, fileList);
      if (file.code == '200') {
        this.process=100;
        this.success=true;
        this.fileId = file.data;
        this.$message.success('上传成功!!!');
        // this.fileList = []
      } else {
        this.process=100;
        this.success=false;
        this.$message.error(file.message);
        this.fileList = [];
      }
      // console.log(fileList);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择1个文件`);
    },
    uploadError(file, fileList) {
      this.process=100;
      this.success=false;
      this.fileList = [];
      // console.log(file)
      // console.log(fileList)
    },
    /* 
    手动上传确认提交
    */
    submitUpload() {
      // console.log("上传" + this.fileId);
      if (this.fileId == "") {
        this.$message.error("请选择要上传的文件！");
        return false;
      }
      importBlackList({
        fileId: this.fileId,
        mobileType: this.mobileType,
        remark: this.remark
      }).then(res => {
        // console.log(res);
        // this.$message.success('提交成功!');
        this.fileId = '';
        this.backTolist()
        this.dialogVisible = false;
        this.fileList = [];
        this.importTotalNum = res.data.uploadTotal;
        this.successNum = res.data.validCount ;
        this.importTipDialog = true;
      }).catch(() =>{
        // console.log(err)
      });
    },
  },
  // 刷新黑名单列表
  mounted() {
    // this.backTolist();
    this.uploadUrl =  blackUploadMobileFile();
  },
  created() {
    // this.backTolist();
  }
};
</script>
<style lang="scss" scoped>
 .warn-tips {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;

    // padding: 0px 15px;
    margin-top: 10px;
    margin-bottom: 20px;
    height:24px;
    // background:rgba(255,185,94,0.1);
    // border:1px solid rgba(255,185,94,1);
    border-radius:2px;
    line-height: 19px;
    color: #999;
    font-size: 14px;
    .warn-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8px;
      font-size: 14px;
      color: #FE8F8A;
    }
    .warn-content {
      display: inline-block;
      vertical-align: middle;
      font-size: 14px;
    }
  }
.procontain{
  text-align:left;
  .proInfo{
    height:20px;
    line-height:20px;
    padding-right:50px;
    overflow:hidden;
    .proclose{
      float:right;
      height:20px;
      line-height:20px;
    }
  }
}
.section-right-content-box {
  color: #666;
  // background-color: #fff;
  /*box-shadow: 0 8px 20px rgba(139, 156, 188, 0.16);*/
  -webkit-border-radius: 8px;
  -moz-border-radius: 8px;
  border-radius: 8px;
  // padding: 22px 30px 26px;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 20px;
  .tips-title {
    height: 32px;
    line-height: 26px;
    background:rgba(248,250,255,1);
    padding-left: 15px;
    margin-bottom: 20px;
    text-align: left;
    border: 1px solid rgba(172,193,254,1);
    .notice-icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 8.49px;
    }
    .notice-content {
      display: inline-block;
      vertical-align: middle;
      .black-type {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        // font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
  }
  .screen-box {
    text-align: left;
    .input-box {
      display: inline-block;
      vertical-align: middle;
      margin-right: 85px;
      // margin-bottom: 10px;
      margin-bottom: 16px;
      .input-title {
        display: inline-block;
        vertical-align: middle;
        font-size: 14px;
        color: #333333;
        width: 70px;
        margin: 0px;
      }
      .input {
        display: inline-block;
        vertical-align: middle;
        width: 200px;
      }
    }
    
  }
  .button-box {
    margin-bottom: 10px;
    .float-left-button {
      float: left;
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        vertical-align: middle;
        padding: 0 16px;
        border: 1px solid #2062e7;
        color: #2062e7;
        font-size: 14px;
        min-width:96px;
        -webkit-border-radius: 2px;
        -moz-border-radius: 2px;
        border-radius: 2px;
        margin-right: 10px;
        cursor: pointer;
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          height:30px;
          line-height:30px;
          vertical-align: middle;
          font-size: 14px;
        }
      }

      .button:last-child {
        margin-right: 0;
      }
    }
    .float-right-button {
      float: right;
      .el-button--small{
        font-size: 14px;
      }
      .button {
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        display: inline-block;
        // vertical-align: middle;
        padding: 5px 12px;
        // border: 1px solid #2062e7;
        // color: #2062e7;
        font-size: 14px;
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;
        margin-right: 10px;
        cursor: pointer;
        .button-icon {
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
        }
        .button-title {
          display: inline-block;
          vertical-align: middle;
        }
      }

      .button:last-child {
        margin-right: 0;
      }
    }
  }
}
/* 添加黑名单 模态框 */
.add-black-list-dialog {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  // width: 368px;
  text-align: left;
  margin: 0 auto;
  .tips {
    display: block;
    font-size: 14px;
    margin-bottom: 6px;
    color: #666;
  }

  .remark-box {
    position: relative;
    margin-bottom: 7px;
    color: #333;
    .remark-tips {
      position: absolute;
      right: 5px;
      bottom: 5px;
      color: #999;
    }
  }
}

/* 加入黑名单 模态框 */
.join-black-list-dialog {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  text-align: left;
  .phoneType {
    margin-bottom: 10px;
  }
  .item {
    margin-bottom: 12px;
    .item-name {
      display: inline-block;
      vertical-align: middle;
      width: 70px;
      text-align: right;
    }
    .highlight-text {
      display: inline-block;
      vertical-align: middle;
      font-size: 24px;
      font-weight: 300;
      color: rgba(255, 118, 0, 1);
      margin-right: 3px;
    }
    .remark-box {
      display: inline-block;
      vertical-align: text-top;
      width: 368px;
      position: relative;
      .remark-tips {
        position: absolute;
        bottom: 5px;
        right: 5px;
        color: #999;
      }
    }
  }
}
//导入手机弹框样式
.textPrompt {
  color: #FD695B;
  margin-left: 60px;
  font-size: 14px;
}
.upFile {
  margin-left: 50px;
  margin-top: 30px;
}
.templateDown {
  border: 1px solid #ccc;
  height: 130px;
  width: 278px;
  .shangFile {
    margin-left: 5px;
    margin-top: 20px;
    padding: 5px 15px;
  }
  .download {
    margin-left: 15px;
    color: blue;
  }
}
.rem {
  position: relative;
  overflow: hidden;
  .em-input{
    // padding-right: 30px
  }
  .quantLimit {
    position: absolute;
    clear: both;
    // left: 390px;
    right: 15px;
    bottom: 5px;
    font-size: 14px;
  }
}

// 时间选择器
.picker {
  display: inline-block;
  vertical-align: middle;
  width: 200px;
}
.dialog-footer {
  text-align: center !important;
}

.search_module{
  padding: 24px 28px 8px 28px;
  background: #fff;
  border-radius: 6px;
  // height: 234px;
  // border: 1px solid rgba(230,230,230,1);
  box-shadow:0px 4px 8px rgba(0,0,0,0.1);
  box-sizing: border-box;
  margin-bottom: 20px;
}
.search_btn{
  width:98px;
  height:32px;
  // background:#5882FB;
  opacity:1;
  border-radius:3px;
  // margin-bottom: 30px;
  // margin-top: 6px;
  font-size: 14px;
  padding: 0px;
}
.table_module{
  padding: 30px 28px 30px;
  background: #fff;
  // border: 1px solid rgba(230,230,230,1);
  box-shadow:0px 4px 8px rgba(0,0,0,0.1);
  opacity: 1;
  border-radius: 6px;
}
.button_icon{
  width: 12px;
  vertical-align: text-top;
  margin-right: 3px;
}
.width_96{
  width: 98px;
}
.width_106{
  width: 106px;
}
.sure_text{
  font-size: 14px;
  // font-family: PingFang SC;
  font-weight: 500;
  line-height: 21px;
  color: rgba(51,51,51,1);
}
.i_icon{
  height: 36px;
  vertical-align: middle;
  margin-right: 20px;
  width: 14px;
  height: 14px;
  background: #fe4d45;
  opacity: 1;
  display: inline-block;
  line-height: 14px;
  text-align: center;
  border-radius: 7px;
  color: #fff;
  font-size: 14px;
  margin: 5px 8px 0 12px;
}
.i_icon2{
  margin: 0 4px 0 0;
  vertical-align: unset;
}

.message_num{
  position: absolute;
  right: 0px;
  top: 0px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #333;
  margin: 14px 20px;
}
.recharge{
  width: 98px;
  height: 32px;
  background: rgba(255,244,244,1);
  border: 1px solid rgba(254,77,69,1);
  opacity: 1;
  border-radius: 3px;
  display: inline-block;
  text-align: center;
  line-height: 30px;
  font-size: 14px;
  /* font-family: PingFang SC; */
  font-weight: 400;
  color: #FE4D45;
  margin-left: 8px;
  cursor: pointer;
}
.tip_module{
  height: 49px;
  background: rgba(255,244,244,1);
  border: 1px solid rgba(254,143,138,1);
  opacity: 1;
  margin-bottom: 20px;
  border-radius:3px;

  font-size: 14px;
  /* font-family: PingFang SC; */
  font-weight: 400;
  line-height: 23px;
  color: #333;
  display: flex;
  
}
.status_btn{
  width:98px;
  // height: 32px;
  background-color: #FFF;
  font-size: 14px;
}
.status_btn2{
  margin-left: 8px;
  color: #333;
  border-color: #d9d9d9;
}
.circle_icon{
  width: 6px;
  height: 6px;
  border-radius: 50%;
  opacity: 1;
  display: inline-block;
  vertical-align: middle;
}
.question_icon{
  width: 14px;
  height: 14px;
  color: #ccc!important;
  display: inline-block;
  line-height: 12px!important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #ccc;
  font-size: 14px!important;
  font-weight: normal!important;
}
.search_item{
  display: inline-block;
  margin-right: 44px;
  margin-bottom: 16px;
  color: #333;
  // @media only screen and (max-width:1590px){
  //   margin-right: 25px;
  // }
  // @media only screen and (max-width:1360px){
  //   margin-right: 15px;
  // }
  .title{
    display: inline-block;
    width: 70px;
    font-size: 14px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    margin: 0px;
  }
}

.top_content{
  background: #fff;
  box-shadow: 0px 4px 4px rgba(0,0,0,0.1);
  opacity: 1;
  color: #333;
  font-size:14px;
  font-weight:500;
  padding: 10px 20px 16px;
  .top_first{
    height: 32px;
    line-height: 32px;
  }
  .top_title{
    height: 28px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    // line-height: 28px;
    margin-right: 16px;
  }
  .top_return{
    height: 20px;
    font-size: 14px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    line-height: 20px;
    padding: 0 90px 0 16px;
    border-left: 1px solid #DDDDDD;
    cursor: pointer;
  }
  .top_edit{
    cursor: pointer;
    margin-left: 10px;
  }
  .top_tips{
    height: 28px;
    background: rgba(254,77,69,0.06);
    border: 1px solid rgba(254,77,69,0.6);
    opacity: 1;
    border-radius: 2px;
    display: inline-block;
    padding: 0 12px;
    line-height: 26px;
    font-size: 14px;
    /* font-family: PingFang SC; */
    font-weight: 400;
    margin-top: 10px;
  }
  .roi_input{
    width: 280px;
    vertical-align: top;
    height: 32px;
    margin-left: 10px;
  }
}

.message_content{
  background: rgba(255,255,255,1);
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
  opacity: 1;
  border-radius: 6px;
  margin: 20px;
  padding: 30px 28px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  .circle_icon2{
    width: 6px;
    height: 6px;
    background: rgba(73,197,104,1);
    border-radius: 50%;
    opacity: 1;
    display: inline-block;
    margin-right: 8px;
    vertical-align: middle;
  }
}

.total_content{
  // height: 400px;
  background: rgba(255,255,255,1);
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
  opacity: 1;
  border-radius: 6px;
  margin: 0 20px;
  padding: 24px 28px 30px;
}
.input_box{
  .input_title{
    display: inline-block;
  }
}

.data_item_all{
  @media only screen and (max-width:1775px){
    .data_item{
      margin-right: 10px;
    }
  }
  @media only screen and (max-width:1920px) and (min-width:1775px){
    display: flex;
    justify-content: space-between;
  }
  
}
.data_item{
  width: 240px;
  // min-height: 284px;
  min-height: 300px;
  background: rgba(255,255,255,1);
  border: 1px solid rgba(243,244,247,1);
  opacity: 1;
  margin-top: 30px;
  display: inline-block;
  vertical-align: top;
  .item_top{
    height: 40px;
    background: rgba(243,244,247,1);
    line-height: 40px;
    font-weight: 500;
    .line{
      width: 4px;
      height: 22px;
      background: rgba(255,135,47,1);
      opacity: 1;
      border-radius: 0px 2px 2px 0px;
      display: inline-block;
      margin-right: 16px;
      vertical-align: middle;
    }
  }
  .item_content{
    padding: 24px 20px;
    .item_content_item{
      line-height: 20px;
      // height: 20px;
      margin-bottom: 10px;
    }
  }
}

.TOP_content2{
  background: rgba(255,255,255,1);
  box-shadow: 0px 4px 8px rgba(0,0,0,0.1);
  opacity: 1;
  border-radius: 6px;
  margin: 20px;
  padding: 16px 0 30px;
  .tab_item_all{
    padding-left: 28px;
    border-bottom: 1px solid #F6F6F6;
  }
  .tab_item{
    /* font-family: PingFang SC; */
    font-weight: 400;
    line-height: 20px;
    color: rgba(153,153,153,1);
    margin-right: 22px;
    display: inline-block;
    margin-right: 22px;
    padding-bottom: 14px;
    cursor: pointer;
  }
  .select_item{
    color: #FE4D45;
    border-bottom: 2px solid #FE4D45;
  }
}

</style>
<style lang="scss">
.sms_record{
  position: relative;
  font-size:14px;
  font-weight:400;
  color:#333;
  // 弹窗样式修改
  // .addBlack_Dialog{
    .el-dialog__header{
      text-align: left;
    }
    .el-dialog__body{
      padding: 24px 30px 30px;
      font-size: 14px;
    }
    .el-dialog__footer{
      padding: 0px 30px 24px;
      .dialog-footer{
        margin-top: 0px;
        text-align: right!important;
      }
    }

  .el-table .cell {
    padding: 0 10px!important;
  }

}  
</style>
